import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import React, { useState } from "react";
import { Base, Box, Brand, Button, Container, Flex, FlexList, Heading, Section, Text } from "./ui";
import * as styles from "./ui.css";
import useIsClient from "./useClient";
import loadable from '@loadable/component'
import ReactHtmlParser from 'react-html-parser';

const BackgroundImage = loadable(() => import('gatsby-background-image'));

export function LogoItem(props) {
  if (!props.image) return null

  return (
    <Brand alt={props.alt} image={props.image.gatsbyImageData} size='medium' />
  )
}

const Circle = ({ outer, outerImage, brands, ...props }) => {
  const size = outer ? 412 : 210;
  const innerSize = outer ? 377 : 175;
  const marginOut = (size - innerSize) / 2;
  const r = innerSize / 2;
  const revanimation = outer ? "full-reverse-rotating 20s linear infinite" : "full-rotating 20s linear infinite";
  const ai = outer ? 0 : Math.PI / 2;

  return (
    <Base as="div" cx={[outer ? styles.outerCircleStyle : styles.innerCircleStyle]}>
      <GatsbyImage
        style={{
          width: innerSize, height: innerSize, marginLeft: marginOut, marginTop: marginOut
        }}
        alt={outerImage.alt}
        image={getImage(outerImage.gatsbyImageData)}
      />
      {brands.map((brand, i) => {
        return (
          <GatsbyImage
            style={{
              animation: revanimation, width: 70, height: 70, position: 'absolute', marginLeft: r * Math.cos(ai + (2 * Math.PI * i) / brands.length) - size / 2 - 20, marginTop: r * Math.sin(ai + (2 * Math.PI * i) / brands.length) + innerSize / 2 - 20
            }}
            alt={brand.alt}
            image={getImage(brand.gatsbyImageData)}
          />
        )
      })}
    </Base>
  )
}


export default function Network(props) {
  return (
    <Section cx={[styles.networkSection]}>
      <Container style={{ height: '100%' }}>
        <Flex cx={[styles.networkFlex]} gap={0}>
          <Box>
            <Text as="h1" variant="h1network" style={{ alignContent: 'center' }}>
              {ReactHtmlParser(props.heading)}
              <Button to={'/network'} variant='primary' cx={[styles.networkButtonTop]}>
                Encontre academias parceiras
              </Button>
            </Text>
          </Box>
          <Box>
            <Base cx={[styles.networkRound]}>
              <Base cx={[styles.networkRoundWrapper]}>
                <Circle brands={props.networkItems[0].brands.slice(0, 6)} outerImage={props.networkItems[1].fullImage} outer />
                <Circle brands={props.networkItems[0].brands.slice(6)} outerImage={props.networkItems[1].icon} />
              </Base>
            </Base>
          </Box>
        </Flex>
      </Container>
    </Section >
  )
}

export const query = graphql`
  fragment HomepageNetworkContent on HomepageNetwork {
    id
    heading
    networkItems {
      ... on ContentfulNetworkImage {
        id
        title
        subtitle
        icon {
          id
          gatsbyImageData
          alt
        }
        fullImage {
          id
          gatsbyImageData(breakpoints: [300,500,1000], width: 400)
          alt
        }
      }
      ... on ContentfulNetworkBrands {
        id
        title
        subtitle
        icon {
          id
          gatsbyImageData
          alt
        }
        brands {
          id
          gatsbyImageData
          alt
        }
      }
    }
  }
`
